import type { Locale } from "vue-i18n";
import { createI18n } from "vue-i18n";
import { en } from "./assets/languages/en";
import { fin } from "./assets/languages/fin";
// Constants
import { LANG } from "@/constants/languages.ts";
// Utils
import { getLocalLanguage } from "@/utils/languageTools.ts";

const datetimeFormats: Record<string, any> = {
  [LANG.EN]: {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
  [LANG.FIN]: {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
};

const locale: Locale = getLocalLanguage();

export const i18n = createI18n({
  locale,
  messages: {
    en,
    fin,
  } as any,
  datetimeFormats,
  legacy: false,
});
